import { Component, Input, Output, EventEmitter } from '@angular/core';
@Component({
	selector: '[leo-popup]',
	templateUrl: "./popup.html",
	styles: [require("./popup.scss")]
})
export class Popup {
	@Input() high: boolean;
	@Input() visible: boolean;
	@Input() popupTitle: string;
	@Input() hideCloseIcon: boolean;
	@Input() closeableByBackdrop: boolean;
	@Output() cancelClicked = new EventEmitter<void>();

	private closePopup() {
		this.cancelClicked.emit()
	}

	private backdropClicked() {
		if (this.closeableByBackdrop) {
			this.closePopup();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/popup/popup.component.ts